import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { PAGE_LAYOUT_OFFSET_TOP } from '@atlassian/jira-common-constants/src/page-layout';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PanelContainer = styled.div({
	boxSizing: 'border-box',
	overflow: 'hidden',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `calc(100vh - ${PAGE_LAYOUT_OFFSET_TOP})`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	borderLeft: `3px solid ${token('color.border', colors.N30)}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PanelHeaderContainer = styled.div({
	boxSizing: 'border-box',
	flexDirection: 'row',
	width: '100%',
	position: 'sticky',
	padding: `${token('space.200', '16px')} ${token('space.200', '16px')} 0 ${token(
		'space.200',
		'16px',
	)}`,
	top: 0,
	zIndex: 99,
	background: token('elevation.surface', '#ffffff'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PanelContentContainer = styled.div({
	position: 'relative',
	overflowY: 'auto',
	overflowX: 'hidden',
	boxSizing: 'border-box',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Header = styled.div({
	marginBottom: token('space.200', '16px'),
	display: 'grid',
	gridTemplateColumns: '1fr auto',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CategoryLozengeGroup = styled.div({
	display: 'flex',
	flexWrap: 'wrap',
	marginTop: token('space.200', '16px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CategoryLozengeClickable = styled.button<{ isActive: boolean | string }>({
	outline: 'none',
	boxSizing: 'border-box',
	padding: `${token('space.050', '4px')} ${token('space.100', '8px')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	backgroundColor: ({ isActive }) =>
		`${
			isActive
				? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
					`${token('color.background.accent.blue.subtler', colors.B50)}`
				: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
					`${token('color.background.accent.gray.subtler', colors.N20A)}`
		}`,
	display: 'inline-flex',
	alignItems: 'center',
	border: 'none',
	borderRadius: '13px',
	height: '26px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	color: ({ isActive }) =>
		`${
			isActive
				? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
					`${token('color.text.accent.blue', colors.B400)}`
				: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
					`${token('color.text.subtle', colors.N500)}`
		}`,
	cursor: 'pointer',
	marginTop: '0px',
	marginBottom: token('space.100', '8px'),
	marginRight: token('space.050', '4px'),
	userSelect: 'none',
	maxWidth: '100%',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
	verticalAlign: 'top',
	gap: token('space.050', '4px'),
});
